<template>
  <v-container
    fluid
    grid-list-md
  >
    <h1>{{ $t('Register Closures') }}</h1>
    <cash-register-reports-table
      class="mt-6"
      include-search
    />
  </v-container>
</template>

<script>
import Vue from 'vue'
import CashRegisterReportsTable from '@/components/cash-register-reports/CashRegisterReportsTable'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    CashRegisterReportsTable
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Register Closures')
  })
}
</script>



// WEBPACK FOOTER //
// src/views/cash-register-reports/Index.vue